module.exports = __webpack_public_path__ + "static/media/vip-baloot.9ea27c4f.png";